import moment from 'moment'
import { TABLA_CAMIONES_DESCARGADOS } from '../../../../../../config/tables'
import { COLUMNS_CAMIONES_DESCARGADOS, COLUMNS_CAMIONES_DESCARGADOS_TO_PRINT } from './constantesCamionesDescargados'
import { pdfCustomToolbarGenerator } from '../../../../../../models/tools/generarPdf'
import ConsultaCea from '../../../../../../models/calado/consulta_cea'
import CargaEntranteAutomotorManual from '../../../../../../models/pesado/carga_entrante_automotor_manual'

export function parseData (data1, data2) {
  const parsedData = []

  if (data1) {
    for (const entry of data1.data) {
      const datosCarga = {
        numero: entry.cartaDePorteAutomotor,
        exportador: entry.exportador,
        chofer: entry.chofer,
        camion: entry.camion,
        detalle: entry
      }

      parsedData.push({
        ...entry,
        exportador: entry.exportador,
        cartadeporte: entry.cartaDePorteAutomotor,
        datosCarga: datosCarga,
        pNeto: (!entry.cereal.startsWith('PEL')) ? entry.pesoNeto : entry.pesoNetoOrigen,
        pNetoOrigen: entry.pesoNetoOrigen,
        fDestare: moment(entry.fechaDeDestare).format('DD-MM-YYYY HH:mm'),
        detalle: entry
      })
    }
  }

  if (data2 && data2.filas_procesadas > 0) {
    for (const entry of data2.filas) {
      const datosCarga = {
        numero: entry.nroComprobanteOrigen,
        exportador: entry.razonSocialExportador,
        chofer: ' ',
        camion: ' ',
        ocultarOperaciones: true,
        detalle: entry
      }
      parsedData.push({
        ...entry,
        exportador: entry.razonSocialExportador,
        datosCarga: datosCarga,
        cartadeporte: entry.nroComprobanteOrigen,
        pNeto: null,
        pNetoOrigen: entry.netoOrigen,
        fDestare: null,
        detalle: entry
      })
    }
  }

  // se ordena por fecha de bruto antes de retornar
  return parsedData.sort((a, b) => {
    if (a.fechaDeVolcado && b.fechaDeVolcado) {
      return a.fechaDeVolcado.localeCompare(b.fechaDeVolcado)
    }
    return parseData
  })
}

export function actualizarDatos (fechaDesde, fechaHasta, filtroInicial = null) {
  return (dispatch, getState) => {
    const state = getState()
    const roles = state.auth.roles
    const rol = roles.filter(roles => roles === 'SINENTREGADOR')

    const fechaD = moment(fechaDesde).format('DD-MM-YYYY')
    const fechaH = moment(fechaHasta).format('DD-MM-YYYY')

    if (rol.length > 0) {
      return dispatch(actualizarDatosParaMuiTableSinEntregador(fechaD, fechaH))
    } else {
      return dispatch(actualizarDatosParaMuiTable(fechaD, fechaH, filtroInicial))
    }
  }
}

export function actualizarDatosParaMuiTable (fechaD, fechaH, filtroInicial = null) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_DESCARGADOS
    })

    Promise.all([
      ConsultaCea.consultaCamionesDescargados(fechaD, fechaH),
      CargaEntranteAutomotorManual.getCargaEntranteAutomotorConRemito(fechaD, fechaH)
    ])
      .then(([d1, d2]) => {
        const data = parseData(d1, d2)

        const customToolbar = pdfCustomToolbarGenerator(
          'Listado de camiones descargados',
          data,
          COLUMNS_CAMIONES_DESCARGADOS_TO_PRINT,
          'portrait'
        )
        const textRowCount = 'Cantidad de camiones: '
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_CAMIONES_DESCARGADOS,
            data: data,
            title: `Camiones descargados`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '520px',
              showRowCount: true,
              textRowCount,
              filtroInicial: filtroInicial
            }
          },
          id: TABLA_CAMIONES_DESCARGADOS
        })
      })
  }
}

export function parseDataSinEntregador (data) {
  const parsedData = []

  if (data) {
    for (const entry of data.data) {
      const datosCarga = {
        numero: entry.cartaDePorteAutomotor,
        exportador: entry.exportador,
        chofer: entry.chofer,
        camion: entry.camion,
        detalle: entry
      }

      parsedData.push({
        ...entry,
        exportador: entry.exportador,
        datosCarga: datosCarga,
        pNeto: entry.pesoNeto,
        fDestare: entry.fechaDeDestare,
        detalle: entry,
        numero: entry.cartaDePorteAutomotor
      })
    }
  }

  // se ordena por fecha de bruto antes de retornar
  return parsedData.sort((a, b) => {
    if (a.fechaDeVolcado && b.fechaDeVolcado) {
      return a.fechaDeVolcado.localeCompare(b.fechaDeVolcado)
    }
    return parseData
  })
}

export function actualizarDatosParaMuiTableSinEntregador (fechaD, fechaH) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_DESCARGADOS
    })

    ConsultaCea.consultaCamionesDescargadosSinEntregador(fechaD, fechaH)
      .then((d) => {
        const data = parseDataSinEntregador(d)
        const customToolbar = pdfCustomToolbarGenerator(
          'Listado de camiones descargados',
          data,
          COLUMNS_CAMIONES_DESCARGADOS_TO_PRINT,
          'portrait'
        )
        const textRowCount = 'Cantidad de camiones: '
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_CAMIONES_DESCARGADOS,
            data: data,
            title: `Camiones descargados`,
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              tableBodyMaxHeight: '599px',
              showRowCount: true,
              textRowCount
            }
          },
          id: TABLA_CAMIONES_DESCARGADOS
        })
      })
  }
}
